
let isLoadedMathjax = false
export default {
    initConfig: function () {
        if (isLoadedMathjax) {
            return
        }
        if (typeof window.MathJax !== 'undefined' && window.MathJax.Hub) {
            isLoadedMathjax = true
            window.MathJax.Hub.Configured()
        }
    },
    renderMathjax (nodes) {
        if (typeof window.MathJax !== 'undefined' && window.MathJax.Hub) {
            if (!isLoadedMathjax) {
                this.initConfig()
            }
            window.MathJax.Hub.Queue(['Typeset', window.MathJax.Hub, nodes])
        }
    }
}
